import React from "react";
import {DashboardCard} from "../../../../designSystem/components/DashboardCard";
import {Typography} from "../../../../designSystem/components/Typography";
import {InformationTable} from "../InformationTable";
import {InformationRow} from "../InformationRow";

import {ICase} from "../../../../types/Case";

interface ApplicationApplicantInformationViewProps {
  caseData: ICase;
}

export const ApplicationApplicantInformationView = ({
  caseData
}: ApplicationApplicantInformationViewProps) => (
  <DashboardCard>
    <Typography variant="subtitle">
      申請人資訊
    </Typography>
    <InformationTable>
      <InformationRow title="姓名" value={caseData.applicantName}/>
      <InformationRow title="服務業務組別" value={caseData.applicantOrganization}/>
      <InformationRow title="職稱" value={caseData.applicantTitle}/>
      <InformationRow title="聯繫電話" value={caseData.applicantPhone}/>
    </InformationTable>
  </DashboardCard>
)
